var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"config-container"},[_c('config-sidebar',{attrs:{"current":_vm.currentTab},on:{"changeTab":(tab) => _vm.currentTab = tab}}),_c('config-main',{attrs:{"current":_vm.currentTab}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }